import { render } from "./PaginationTable.vue?vue&type=template&id=42dc1770"
import script from "./PaginationTable.vue?vue&type=script&lang=js"
export * from "./PaginationTable.vue?vue&type=script&lang=js"

import "./PaginationTable.vue?vue&type=style&index=0&id=42dc1770&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__